exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host{display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./download_app/es-US/js/download-app-page/download-app-page.css
// module id = rloG
// module chunks = 14